module.exports = "/images/video.jpg?c0bc1259c0e20997e487d3ee8e43ffdd";